import { proposeNewTime } from 'owa-locstrings/lib/strings/proposenewtime.locstring.json';
import { declineEventAndAddMessage } from 'owa-locstrings/lib/strings/declineeventandaddmessage.locstring.json';
import { tentativelyAcceptEventAndAddMessage } from 'owa-locstrings/lib/strings/tentativelyaccepteventandaddmessage.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import MeetingActionButton from './MeetingActionButton';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import popoutCalendarReadingPane from 'owa-popout/lib/utils/popout/popoutCalendarReadingPane';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { MeetingMessageActionType } from '../utils/MeetingMessageActionType';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export interface ProposeNewTimeButtonProps {
    item: MeetingRequestMessageType;
    logAction: (interactionType: MeetingMessageActionType, propertyNames?: string[]) => void;
}

@observer
export default class ProposeNewTimeButton extends React.Component<ProposeNewTimeButtonProps, {}> {
    render() {
        return (
            <MeetingActionButton
                text={loc(proposeNewTime)}
                secondary={true}
                iconProps={{
                    iconName: ControlIcons.Clock,
                }}
                menuProps={{
                    items: this.getProposeNewTimeMenuItems(),
                }}
            />
        );
    }

    private getProposeNewTimeMenuItems = (): IContextualMenuItem[] => {
        return [
            {
                key: 'proposeNewTimeTentative',
                name: loc(tentativelyAcceptEventAndAddMessage),
                onClick: this.createProposeNewTimeClickHandler('Tentative'),
            },
            {
                key: 'proposeNewTimeDecline',
                name: loc(declineEventAndAddMessage),
                onClick: this.createProposeNewTimeClickHandler('Decline'),
            },
        ];
    };

    private createProposeNewTimeClickHandler(responseType: 'Tentative' | 'Decline') {
        const { item, logAction } = this.props;

        return () => {
            popoutCalendarReadingPane(
                item.AssociatedCalendarItemId.Id,
                'Mail_MeetingRequestProposeNewTime',
                {
                    responseType: responseType,
                    meetingMessageId: item.ItemId.Id,
                }
            );
            logAction(responseType === 'Tentative' ? 'PNTTentativeStarted' : 'PNTDeclineStarted');
        };
    }
}
